/*global angular */
/*jslint node: true */

'use strict';

var youtube = angular.module('youtube', []);

// todo: same filter defined here: src/client/app/components/lib/msVideobackground.js
youtube.filter('trustUrl', ['$sce', function ($sce) {
    return function (recordingUrl) {
        return $sce.trustAsResourceUrl(recordingUrl);
    };
}]);

youtube.filter('youtubeVideoIdFromUrl', ['$sce', function ($sce) {
    return function (yt_video_url) {
        if (yt_video_url) {
            var video_id = yt_video_url.split('v=')[1];
            if (video_id) {
                var ampersandPosition = video_id.indexOf('&');
                if (ampersandPosition != -1) {
                    video_id = video_id.substring(0, ampersandPosition);
                }
            }
            return video_id;
        }

        return null;
    };
}]);


/** @type {{}|*} */
var availableOptionsWithDefaultValue = {
    'autoplay': 0,
    'controls': 1,
    'theme': 'dark',
    'start': 0,
    'end': 0,
    'fs': 1,
    'cc_load_policy': 0, // omit
    'color': 'red',
    'showinfo': 0,
    'autohide': 2,
    'disablekb': 0,
    'modestbranding': 0,
    'playsinline': 0,
    'rel': 0
};

youtube.filter('embedOptions', ['$sce', function ($sce) {
    return function (yt_video_url, config) {
        var str = [];
        for (var option in availableOptionsWithDefaultValue) {
            if (availableOptionsWithDefaultValue.hasOwnProperty(option) && config.hasOwnProperty(option)) {
                str.push(encodeURIComponent(option) + "=" + encodeURIComponent(config[option]));
            }
        }
        return yt_video_url + str.join("&");
    };
}]);

youtube.service('youtubeSlot', ['$templateCache', function ($templateCache) {
    return {
        /**
         * @param slot {msSlot}
         * @param scope
         */
        initializeSlot: function (slot, scope) {
            // todo: console.log('initializing slot ...', slot);
            slot.settings = angular.copy(availableOptionsWithDefaultValue);
        },
        getTemplate: function () {
            return $templateCache.get('slots/youtube/youtube.html');
        },
        config: {
            title: 'YouTube',
            visible: function (context_type, context) {
                return context_type == 'slot' && context.type == 'youtube';
            },
            template: $templateCache.get('slots/youtube/youtube_config.html')
        }
    };
}]);
